import { buttonVariants } from '../enums';

export default {
  props: {
    type: {
      type: String,
      default: buttonVariants.PRIMARY,
      required: false,
      validator: (value) => Object.values(buttonVariants).includes(value),
    },
  },
};
